module.exports = __webpack_public_path__ + "images/category_lp/watch/reason2_ff22d47e7a3bd63b3dff1ff59113ad07.png";